import { useQuery } from '@tanstack/react-query';
import { awaitJSON, MetaLambdaFetch } from '@src/utils/fetch-utils';
import { EMQScores } from './signal-dashboard-constants';

export const useEmqScores = (company: string): ReturnType<typeof useQuery<EMQScores[]>> =>
  useQuery({
    queryKey: ['emqScores', company],
    enabled: Boolean(company),
    queryFn: async (): Promise<EMQScores[]> =>
      awaitJSON<EMQScores[]>(await MetaLambdaFetch('/getEMQScores', { params: { company } }))
  });
